import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";

import UserPanelHeader from "./../components/UserPanelHeader";
import UserPanelSearchModal from "../components/UserPanelSearchModal";
import Sidebar from "../components/Sidebar/Sidebar";

const cssFiles = [
  "/assets/UserPanelAssets/css/bootstrap.min.css",
  "/assets/UserPanelAssets/css/bootstrap-datetimepicker.min.css",
  "/assets/UserPanelAssets/plugins/daterangepicker/daterangepicker.css",
  "/assets/UserPanelAssets/plugins/fontawesome/css/fontawesome.min.css",
  "/assets/UserPanelAssets/plugins/fontawesome/css/all.min.css",
  "/assets/UserPanelAssets/plugins/tabler-icons/tabler-icons.min.css",
  "/assets/UserPanelAssets/plugins/simplebar/simplebar.min.css",
  "/assets/UserPanelAssets/css/style.css",
  "/assets/UserPanelAssets/css/customUserPanel.css",
];

export default function UserPanelLayout({ children, production, SideBar }) {
  const [cssLoaded, setCssLoaded] = useState(false);

  const [OpenMenu, setOpenMenu] = useState(false);
  const [HideWeb, setHideWeb] = useState(false);

  const toggleMenuSidebar = () => {
    setOpenMenu((prev) => !prev);
  };

  const toggleWebMenu = () => {
    setHideWeb((prev) => !prev);
  };

  useEffect(() => {
    let loadedCount = 0;
    const links = cssFiles.map((href) => {
      const link = document.createElement("link");
      link.rel = "stylesheet";
      link.href = href;
      link.dataset.theme = "ayurveda";

      // Increment counter when each CSS finishes loading
      link.onload = () => {
        loadedCount++;
        if (loadedCount === cssFiles.length) {
          setCssLoaded(true);
        }
      };

      document.head.appendChild(link);
      return link;
    });

    // Cleanup on unmount
    return () => {
      links.forEach((link) => link.remove());
    };
  }, []);

  // Don't render children until CSS is fully loaded
  if (!cssLoaded) {
    return <div style={{ visibility: "hidden" }}>Loading...</div>;
  }

  return (
    <div class={`main-wrapper ${HideWeb == true ? "mini-sidebar" : ""} `}>
      <UserPanelHeader
        OpenMenu={OpenMenu}
        toggleMenuSidebar={toggleMenuSidebar}
      />
      <UserPanelSearchModal />
      <Sidebar
        SideBar={SideBar}
        OpenMenu={OpenMenu}
        toggleMenuSidebar={toggleMenuSidebar}
        HideWeb={HideWeb}
        toggleWebMenu={toggleWebMenu}
      />
      <main>
        <div className="page-wrapper" data-aos="fade-up">
          {children}

          <div className="footer text-center bg-white p-2 border-top">
            <p className="text-dark mb-0">
              {new Date().getFullYear()} &copy;{" "}
              <Link to="/dashboard" className="link-primary">
                Bharat Dhara
              </Link>
              , All Rights Reserved
            </p>
          </div>
        </div>
      </main>
    </div>
  );
}
